import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiagramRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 7.2q.7.1.8.8 0 1-.8.8H8q-.7-.1-.8-.8 0-1 .8-.8zM8 4.8A3 3 0 0 0 4.8 8c0 1.8 1.4 3.2 3.2 3.2h6.8v.8l-2 2-.4.4H9.6a4.4 4.4 0 0 0-4.4 4.4v2h-.4q-1.5.1-1.6 1.6v3.2q.1 1.5 1.6 1.6H8q1.5-.1 1.6-1.6v-3.2q-.1-1.5-1.6-1.6h-.4v-2a2 2 0 0 1 2-2h2.8l1.9 2 .5.4v1.6h-.4q-1.5.1-1.6 1.6v3.2q.1 1.5 1.6 1.6h3.2q1.5-.1 1.6-1.6v-3.2q-.1-1.5-1.6-1.6h-.4v-1.6l2.4-2.4h2.8a2 2 0 0 1 2 2v2H24q-1.5.1-1.6 1.6v3.2q.1 1.5 1.6 1.6h3.2q1.5-.1 1.6-1.6v-3.2q-.1-1.5-1.6-1.6h-.4v-2a4.4 4.4 0 0 0-4.4-4.4h-2.8l-2-1.9-.4-.5v-.8H24a3.2 3.2 0 0 0 0-6.4zm-2.4 20v-1.6h1.6v1.6zm9.6 0v-1.6h1.6v1.6zm9.6 0v-1.6h1.6v1.6zm-10.2-9.2 1.4-1.4 1.4 1.4L16 17z" })
});
export default SvgDiagramRegularIcon;
